import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'packages/throttle';
import logger from 'packages/logger';
import axios from 'axios';
// import Storage from '../../app/data/storage-service';
import {
    PreviousSearchesListItem,
    SearchesSuggestionsListItem,
    ShopsSuggestionsListItem,
    AdvancedSearchListItem
} from './suggestion-list-items';

class SearchSuggestion extends React.Component {

    constructor(props) {
        super(props);
        // this.getSuggestions = throttle(this.getSuggestions, 500);
        this.state = {
            searchTerm: props.searchTerm,
            searchSuggestions: {
                searches: [],
                shops: []
            }
        }
    }

    render() {
        const {
            searchTerm,
            isSearchInputFocussed,
            suggestedSearches,
            suggestedShops,
            filteredPreviousSearches,
            selectedIndex,
            setSearchSuggestionsElement,
            selectedCategoryId
        } = this.props;

        const changeSearchTerm = e => {
            // console.log(e);
        }

        const suggestionTypes = {
            PREVIOUS_SEARCH: 'PREVIOUS_SEARCH',
            SUGGESTED_SEARCH: 'SUGGESTED_SEARCH',
            SUGGESTED_SHOP: 'SUGGESTED_SHOP',
            ADVANCED_SEARCH: 'ADVANCED_SEARCH'
        };

        const getComponent = (item, index) => {
            const isSelected = index === selectedIndex;
            const components = {

                [suggestionTypes.PREVIOUS_SEARCH]:
                    <PreviousSearchesListItem
                        {...item.jsxProps}
                        isSelected={isSelected}
                        selectedCategoryId={selectedCategoryId} />,

                [suggestionTypes.SUGGESTED_SEARCH]:
                    <SearchesSuggestionsListItem
                        {...item.jsxProps}
                        isSelected={isSelected}
                        selectedCategoryId={selectedCategoryId} />,

                [suggestionTypes.SUGGESTED_SHOP]:
                    <ShopsSuggestionsListItem
                        {...item.jsxProps} isSelected={isSelected} />,

                [suggestionTypes.ADVANCED_SEARCH]:
                    <AdvancedSearchListItem
                        {...item.jsxProps} isSelected={isSelected} />

            }

            if (components[item.type]) {
                return components[item.type];
            }
        }

        const allSuggestions = []
            .concat((filteredPreviousSearches || [])
                .map((i, key) =>
                    ({
                        type: suggestionTypes.PREVIOUS_SEARCH,
                        key: key,
                        jsxProps: {
                            item: i,
                            key: key,
                            searchTerm: searchTerm,
                            changeSearchTerm: changeSearchTerm
                        }
                    })
                )
            )
            .concat((suggestedSearches || [])
                .map((i, key) => ({
                    type: suggestionTypes.SUGGESTED_SEARCH,
                    text: i.text,
                    categories: i.categories,
                    jsxProps: {
                        item: i,
                        key: `${suggestionTypes.SUGGESTED_SEARCH}-${key}`,
                        searchTerm: searchTerm,
                        changeSearchTerm: changeSearchTerm
                    }
                })
                )
            )
            .concat((suggestedShops || [])
                .map((i, key) => ({
                    type: suggestionTypes.SUGGESTED_SHOP,
                    memberId: i.memberId,
                    name: i.name,
                    urlName: i.urlName,
                    jsxProps: {
                        item: i,
                        key: `${suggestionTypes.SUGGESTED_SHOP}-${key}`,
                        searchTerm: searchTerm,
                        changeSearchTerm: changeSearchTerm
                    }
                })
                )
            );

        allSuggestions.push({
            type: suggestionTypes.ADVANCED_SEARCH,
            jsxProps: {
                key: `advanced-search`
            }
        });

        // Dont blur input when there's a mouseclick on the search suggestions
        const preventDefault = evt => {
            evt.preventDefault();
        };

        const suggestions2show = allSuggestions.map((i, index) => getComponent(i, index));

        return (
            <section className={`slim-header__search-suggestions ${isSearchInputFocussed ? 'visible' : ''}`} ref={setSearchSuggestionsElement} >
                {
                    isSearchInputFocussed ?
                        <div className="list-group">
                            {suggestions2show}
                        </div>
                        : null
                }
            </section>
        )
    }
};

// TODO
SearchSuggestion.propTypes = {
    searchTerm: PropTypes.string,
    previousSearches: PropTypes.array,
    isSearchInputFocussed: PropTypes.bool,
    filteredPreviousSearches: PropTypes.array,
    suggestedSearches: PropTypes.array,
    suggestedShops: PropTypes.array,
    selectedIndex: PropTypes.number,
    onChangeSearchTerm: PropTypes.func,
    setSearchSuggestionsElement: PropTypes.func,
    selectedCategoryId: PropTypes.number
};

// filteredPreviousSearches={this.state.searchSuggestions.previousSearches}
// suggestedSearches={this.state.searchSuggestions.searches}
// suggestedShops={this.state.searchSuggestions.shops}
// selectedIndex={this.state.searchSuggestions.selectedIndex}
// searchTerm={this.state.searchTerm}
// onChangeSearchTerm={this.handleSuggestionsChangingSearchTerm}
// isSearchInputFocussed={this.state.isSearchInputFocussed}
// setSearchSuggestionsElement={this.setSearchSuggestionsElement}
// selectedCategoryId={this.state.selectedCategoryId}

export default SearchSuggestion;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-suggestion/search-suggestion.jsx